module.exports = __webpack_public_path__ + "static/media/almas.8b4184cf.png";